export const COLI_DASHBOARD_COUNT_SUCCESS = 'COLI_DASHBOARD_COUNT_SUCCESS';
export const COLI_DASHBOARD_COUNT_FAILURE = 'COLI_DASHBOARD_COUNT_FAILURE';
export const COLI_DASHBOARD_LIST_SUCCESS = 'COLI_DASHBOARD_LIST_SUCCESS';
export const COLI_DASHBOARD_LIST_FAILURE = 'COLI_DASHBOARD_LIST_FAILURE';
